var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldOmegaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm11.9 5.25c-.3 0-.57-.17-.69-.45a.75.75 0 0 1 .13-.81l1.62-1.79c.67-.75 1.05-1.7 1.05-2.68 0-1-.41-1.94-1.16-2.65A4.182 4.182 0 0 0 12 7.75c-1.06 0-2.1.41-2.85 1.12-.75.71-1.16 1.65-1.16 2.65 0 .98.37 1.93 1.05 2.68l1.61 1.8a.753.753 0 0 1-.56 1.26H7c-.41 0-.75-.34-.75-.75s.34-.76.75-.76h1.41l-.49-.54a5.507 5.507 0 0 1-1.43-3.69c0-1.39.59-2.76 1.63-3.74 1.04-.99 2.41-1.53 3.88-1.53 1.47 0 2.84.54 3.88 1.53 1.03.98 1.63 2.35 1.63 3.74 0 1.35-.51 2.66-1.43 3.69l-.49.54H17c.41 0 .75.34.75.75s-.34.75-.75.75h-3.1z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldOmegaCircle);
export default __webpack_public_path__ + "static/media/vuesax-bold-omega-circle.77254263e9dc986cd07fab2ed979c98a.svg";
export { ForwardRef as ReactComponent };